//@ts-check
import {LabelWithVal} from '@/containers/Promotions/PromotionsReview/LabelWithVal'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {ProductComboSteps} from '@/types/productComboTypes'
import {Font} from 'pepsico-ds'
import {ComboReviewSection} from './ComboReviewSection'

export const ComboReviewSetup = () => {
  const {
    productCombo: {name, active, segmentConfiguration, allCustomers, routeTypeId, comboLimit},
  } = useProductCombo()

  const includedSegments = segmentConfiguration?.includedSegments?.[0]?.segments ?? []
  const excludedSegments = segmentConfiguration?.excludedSegment?.segments ?? []
  let segmentsLabel = '-'
  let excluding = 'No'
  if (includedSegments.length > 0) {
    segmentsLabel = includedSegments.map(seg => seg.segmentName || seg.segmentId).join(', ')
  } else if (excludedSegments.length > 0) {
    segmentsLabel = excludedSegments.map(seg => seg.segmentName || seg.segmentId).join(', ')
    excluding = 'Yes'
  }

  return (
    <ComboReviewSection
      label="Setup"
      step={ProductComboSteps.SETUP}
      content={
        <div className="flex w-full flex-col gap-6 overflow-hidden">
          <div>
            <Font size="small" variant="bold">
              Combo Setup
            </Font>
            <div className="mt-2 h-px bg-gray-600" />
            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-3">
              <LabelWithVal keyName="Combo Name" val={name} />
              <LabelWithVal keyName="Combo Limit" val={comboLimit} />
            </div>
          </div>
          <div>
            <Font size="small" variant="bold">
              Availability
            </Font>
            <div className="mt-2 h-px bg-gray-600" />
            <LabelWithVal keyName="Active" val={active ? 'Yes' : 'No'} />
          </div>
          <div>
            <Font size="small" variant="bold">
              Segments
            </Font>
            <div className="mt-2 h-px bg-gray-600" />
            <div className="grid grid-cols-1 gap-x-4 md:grid-cols-3">
              <LabelWithVal keyName="All Customers" val={allCustomers ? 'Yes' : 'No'} />
              <LabelWithVal keyName="Segments" val={segmentsLabel} />
              <LabelWithVal keyName="Excluding" val={excluding} />
              <LabelWithVal keyName="Route Type ID" val={routeTypeId || '-'} />
            </div>
          </div>
        </div>
      }
    />
  )
}
